import React from 'react';
import './Home.js.css';
import Container from '../components/Container';
import '../styles/generics.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PageComponent from '../components/PageComponent';
import Labels from '../Labels';
import Connection from '../config/Connection';
import { Modal, Button, InputGroup, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Parsers from '../Tools/Parsers';
import GenericHelper from '../Tools/GenericHelper';
import AdminPage from './AdminPage';
import ErrorComponent from '../components/ErrorComponent';
import MaskedInput from '../components/MaskedInput';

export default class ProvidersPage extends PageComponent {

  static PageInfo = {
    parent: AdminPage,
    path: "/Admin/Providers",
    name: "menu.providers",
    permission: { "CONFIGURATION_USERS_LIST": true },
    access: { 1: true },
    icon: "city"
  }

  constructor(props) {
    super(props);
    this.state.loading = true;
    this.state.isModalVisible = null;
    this.state.modalInitializing = false;
    this.state.modalError = null;
    this.state.modalLoading = false;
    this.state.user = "";
  }

  componentDidMount() {

    Connection.Secure(Connection.service + 'Company/List/3')
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then((data) => {
            setTimeout(() => this.setState({ data: data, loading: false }));
          });
        else this.setState({ error: response, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error, loading: false });
      });
  }

  checkForm(target) {
    for (var i in target)
      if (target[i] == null) return false;
    return true;
  }
  updateForm(target, value) {
    this.state.form[target] = value;
    this.setState({ form: this.state.form });
  }

  openModal(target) {
    var t = {
      isModalVisible: target,
      modalLoading: false,
      modalInitializing: false,
      modalError: null
    };
    t.form = {};
    this.setState(t);
  }

  saveUser() {
    this.state.form.mainKeyCriticalType = { keyConstant: 2 };
    Connection.Secure(Connection.service + 'Company',
      {
        "method": "POST",
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(this.state.form)
      })
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then((data) => {
            var l = ("/Admin/Providers/Detail/" + data);
            this.setState({ isModalVisible: false, modalLoading: false },
              () => this.props.history.push(l));
          });
        this.setState({ modalError: response, modalLoading: false });
      })
      .catch((error) => {
        this.setState({ modalError: error, modalLoading: false });
      });
    this.setState({ modalLoading: true });
  }

  render() {
    return (
      <Container context={this.constructor}>

        <div className="generics_panels" style={{ display: "block" }}>
          {
            this.state.error != null ? <ErrorComponent error={this.state.error} /> :
              this.state.loading ? <div>{Labels.GetLabel("generic.loading")}</div> :
                <div>
                  <div className="generics_panels_header"><FontAwesomeIcon icon={this.constructor.PageInfo.icon} /> <span>{Labels.GetLabel(this.constructor.PageInfo.name)}</span></div>
                  {this.state.data
                    && this.state.data.length > 0 ? this.state.data.map((item) =>
                      <Link to={"/Admin/Providers/Detail/" + item.keyRegister} className="generics_listing_item" >
                        <FontAwesomeIcon icon="store" className="generics_listing_item_icon" />
                        <div className="generics_listing_content" >
                          <div className="generics_listing_item_title" >{Parsers.parseUpperCase(item.name)}</div>
                          <div className="generics_listing_item_description" >{item.criticalValue}</div>
                        </div>
                      </Link>
                    )
                    : null}
                </div>
          }
          <div className="generics_floatinbtn" onClick={() => this.openModal('new')}>
            <FontAwesomeIcon className="generics_floatinbtn_icon" icon="plus" />
          </div>

          <Modal
            className={this.state.modalLoading == true ? "modal-loading" : ""}
            onHide={() => { }} show={this.state.isModalVisible != null}
          // onHide={handleClose}
          >
            <div>
              {
                this.state.modalInitializing == true ? <div>
                  {Labels.GetLabel("adminuserpage.saving")}
                </div> :
                  this.state.isModalVisible == 'new' ?
                    <div>
                      <Modal.Header>
                        <Modal.Title>{Labels.GetLabel("provider.new")}</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <MaskedInput type="text" icon="info-circle" label={Labels.GetLabel("clients.social")} notnull={true} onValid={(value) => this.updateForm("name", value)}
                          onInvalid={(value) => this.updateForm("name", null)} />
                        <MaskedInput key={2} icon="id-card" type="cnpj" value={null} notnull={true} onValid={(value) => this.updateForm("criticalValue", value)} label={Labels.GetLabel("information.DOC_CNPJ")}
                          onInvalid={(value) => this.updateForm("criticalValue", null)} />
                      </Modal.Body>
                      <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.setState({ isModalVisible: false })}>
                          {Labels.GetLabel("adminuserpage.closebtn")}
                        </Button>
                        <Button variant="primary" disabled={!this.checkForm(this.state.form)} onClick={() => this.saveUser()}>
                          {Labels.GetLabel("adminuserpage.savebtn")}
                        </Button>
                      </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                    </div>
                    : null
              }
            </div>
          </Modal>
        </div>
      </Container >
    );
  }
}